/** @format */

import React, { FunctionComponent, useState } from 'react'
import styled from 'styled-components'
import { HashRouter, Switch, Redirect } from 'react-router-dom'
import { Layout, Body } from '@king-design/react'
import SiderBar from './components/SiderBar/index'
import MonitorGeneral from './pages/MonitorGeneral'
import MonitorMenu from './pages/MonitorMenu'
import MonitorCloudChart from './pages/MonitorCloud/MonitorCloudChart'
import MonitorCloudList from './pages/MonitorCloud/MonitorCloudList'
import MonitorClouOuterView from './pages/MonitorCloud/MonitorClouOuterView'
import MonitorAlarmTactics from './pages/MonitorAlarm/MonitorAlarmTactics'
import MonitorAlarmHistory from './pages/MonitorAlarm/MonitorAlarmHistory'
import MonitorCreate from 'src/containers/MonitorCreate'
import MonitorEditEvent from 'src/containers/EventCenter/EditEvent'
import MonitorAlarming from './pages/MonitorAlarm/MonitorAlarming'
import EventConter from './pages/EventCenter'
import CustommonitorAlarm from './pages/MonitorCustommonitor/CustommonitorAlarm'
import CustommonitorTarget from './pages/MonitorCustommonitor/CustommonitorTarget'
import AlarmEventDetail from 'src/pages/MonitorAlarm/MonitorAlarmHistory/AlarmEventDetail'
import TacticsDetail from 'src/pages/MonitorAlarm/MonitorAlarmHistory/TacticsDetail'
import MonitorAlarmTemplate from './pages/MonitorAlarm/MonitorAlarmTemplate'
import MonitorAlarmTemplateEdit from './containers/MonitorAlarmTemplate/Edit'
import MonitorAlarmSilences from './pages/MonitorAlarm/MonitorAlarmSilences'
import MonitorAlarmTarget from './pages/MonitorAlarm/MonitorAlarmTarget'
import ContactsScheduleEditPage from './pages/MonitorAlarm/MonitorAlarmTarget/Schedule/EditPage'
import MonitorGroup from './pages/MonitorGroup'
import MonitorGroupDetails from './pages/MonitorGroup/GroupDetails'
import MonitorDashboard from './pages/MonitorDashboard'
import CustomboardPage from './pages/MonitorDashboard/Customboard/CustomboardPage'
import CustomboardGraphEditPage from './pages/MonitorDashboard/Customboard/CustomboardGraphEditPage'
import InstanceList from './pages/PrometheusMonitor/InstanceList'
import PrometheusInstanceInfoView from './pages/PrometheusMonitor/InstanceList/view'
import PrometheusMetricExplore from './pages/PrometheusMonitor/MetircExplore'
import PrometheusAlarm from './pages/PrometheusMonitor/Alarm'
import PrometheusAlarmEdit from './pages/PrometheusMonitor/Alarm/EditPage'
import PrometheusAlarmView from './pages/PrometheusMonitor/Alarm/ViewPage'
import GrafanaInstanceInfo from './pages/Grafana/InstanceInfo'
import GrafanaInstanceInfoView from './pages/Grafana/InstanceInfo/view'
import EventOpsTrigger from './pages/EventOps/Trigger'
import EventOpsTriggerRecord from './pages/EventOps/Trigger/Record'
import EventOpsApprove from './pages/EventOps/Approve'
import EventOpsScene from './pages/EventOps/Scene'
import EventOpsSceneDetail from './pages/EventOps/Scene/Detail'
import EventOpsSceneLaunch from './pages/EventOps/Scene/Launch'
import EventOpsRecord from './pages/EventOps/Record'
import EventOpsRecordDetail from './pages/EventOps/Record/Detail'
import EventOpsFunctions from './pages/EventOps/Functions'
import EventOpsFunctionDetail from './pages/EventOps/Functions/Detail'
import EventOpsFunctionApprove from './pages/EventOps/Functions/Approve'
import DenoiseInhibitionEdit from './containers/PrometheusMonitor/Alarm/Denoise/Inhibition/EditPage'
import DenoiseSilenceEdit from './containers/PrometheusMonitor/Alarm/Denoise/Silence/EditPage'
import CustomRoute from './components/CustomRoute'
// AI可观测
import ServiceOverview from './pages/AIObservability/ServiceOverview'
import SessionAnalysis from './pages/AIObservability/SessionAnalysis'
import TraceAnalysis from './pages/AIObservability/TraceAnalysis'
import AccessCenter from './pages/AIObservability/AccessCenter'
import ServiceDetail from './pages/AIObservability/ServiceOverview/ServiceDetail'
import SessionDetail from './pages/AIObservability/SessionAnalysis/SessionDetail'
import TraceDetail from './pages/AIObservability/TraceAnalysis/TraceDetail'
import TestPage from './TestPage'
import useGlobalData from 'src/hooks/useGlobalData'
// 隐藏右侧浮窗栏
const IS_TOP_WINDOW = window.self === window.top

const HashRouterComponent = HashRouter
const SwitchComponent = Switch
const RedirectComponent = Redirect
const App: FunctionComponent<{ className?: string }> = ({ className }) => {
  const [menuState, setMenuState] = useState(false)
  const productMenu = useGlobalData('productMenu')

  // if (!isSelf) {
  //   const right = document.getElementById('ksf-right-function')
  //   right && (right.style.display = 'none')
  // }

  return (
    <HashRouterComponent
      basename={window?.['__POWERED_BY_QIANKUN__'] ? '/ksc-monitor-web' : '/'}
      hashType="hashbang"
    >
      {productMenu?.length ? (
        <Layout className={`${className} ksc-monitor-third-btn`}>
          {IS_TOP_WINDOW ? <SiderBar menuState={menuState} setMenuState={setMenuState} /> : null}
          <Body
            className={
              IS_TOP_WINDOW && !menuState ? 'monitor-body' : 'monitor-body monitor-body-out'
            }
          >
            <SwitchComponent>
              {/* TEST */}
              <CustomRoute exact path="/monitor/test" component={TestPage}></CustomRoute>
              {/* 概览 */}
              <CustomRoute
                exact
                path="/monitor/generalview/home"
                component={MonitorGeneral}
              ></CustomRoute>
              {/* 云服务类别 */}
              <CustomRoute exact path="/monitor/menu" component={MonitorMenu}></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/list/:name"
                component={MonitorCloudList}
              ></CustomRoute>
              {/* 云服务类别-图表页 */}
              <CustomRoute
                exact
                path={[
                  // eslint-disable-next-line max-len
                  '/monitor/list/overview/:productType/:instanceId/:instanceName/:topType/:regionName',
                  // eslint-disable-next-line max-len
                  '/monitor/list/overview/:instanceName/:instanceId/:productType/:page/:prdocutName/:regionName',
                  // eslint-disable-next-line max-len
                  '/monitor/list/overview/:instanceName/:instanceId/:productType/:page/:prdocutName/:regionName/:topType'
                ]}
                component={MonitorCloudChart}
              ></CustomRoute>
              {/* 云服务类别-图表页-外部跳转 */}
              <CustomRoute
                exact
                path={[
                  // eslint-disable-next-line max-len
                  '/monitor/detail/:instanceName/:instanceId/:page/:regionName',
                  // eslint-disable-next-line max-len
                  '/monitor/detail/:instanceName/:instanceId/:page/:regionName/:productType'
                ]}
                component={MonitorClouOuterView}
              ></CustomRoute>
              {/* 自定义监控-指标 */}
              <CustomRoute
                exact
                path={[
                  '/monitor/custom/metric',
                  '/monitor/custom/metric/:region/:namespace/:metricKey/:dimension'
                ]}
                component={CustommonitorTarget}
              ></CustomRoute>

              {/* 自定义监控-告警 */}
              <CustomRoute
                exact
                path="/monitor/custom/alarm"
                component={CustommonitorAlarm}
              ></CustomRoute>
              {/* 自定义监控-事件中心 */}
              <CustomRoute
                exact
                path="/monitor/systomcenter/home"
                component={EventConter}
              ></CustomRoute>
              {/* 告警策略-事件告警历史 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/history/detail/event/:policyName"
                component={AlarmEventDetail}
              ></CustomRoute>
              {/* 告警策略-阈值告警历史 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/history/detail/:policyId/:policyName"
                component={TacticsDetail}
              ></CustomRoute>
              {/* 告警策略 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/rule/home"
                component={MonitorAlarmTactics}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/alarmServer/history/home"
                component={MonitorAlarmHistory}
              ></CustomRoute>
              {/* 编辑阈值告警策略 */}
              <CustomRoute
                path={[
                  `/monitor/alarmServer/rule/create/:productType`,
                  '/monitor/alarmServer/rule/create',
                  '/monitor/alarmServer/rule/detail/:policyId',
                  '/monitor/alarmServer/rule/detail/:policyId/:resourceBindType'
                  // `/monitor/alarmServer/tactics/edit/:id/:productType`,
                  // `/monitor/alarmServer/tactics/edit/:id`
                ]}
                component={MonitorCreate}
              ></CustomRoute>
              {/* 编辑事件告警策略 */}
              <CustomRoute
                exact
                path={[
                  '/monitor/alarmServer/rule/createEvent',
                  '/monitor/alarmServer/rule/editEvent/:policyName'
                ]}
                component={MonitorEditEvent}
              ></CustomRoute>
              {/* 正在告警 */}
              <CustomRoute
                exact
                path={[
                  '/monitor/alarmServer/alarming/home',
                  '/monitor/alarmServer/alarming/home/:productType'
                ]}
                component={MonitorAlarming}
              ></CustomRoute>
              {/* 触发条件模板 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/template/home"
                component={MonitorAlarmTemplate}
              ></CustomRoute>
              <CustomRoute
                exact
                path={[
                  `/monitor/alarmServer/template/edit`,
                  '/monitor/alarmServer/template/edit/:id'
                ]}
                component={MonitorAlarmTemplateEdit}
              ></CustomRoute>
              {/* 告警屏蔽 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/silences/home"
                component={MonitorAlarmSilences}
              ></CustomRoute>
              {/* 通知对象 */}
              <CustomRoute
                exact
                path="/monitor/alarmServer/alertTarget"
                component={MonitorAlarmTarget}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/alarmServer/alertTarget/schedule/edit"
                component={ContactsScheduleEditPage}
              ></CustomRoute>
              {/* 资源组管理 */}
              <CustomRoute exact path="/monitor/group/home" component={MonitorGroup}></CustomRoute>
              {/* 资源组管理-详情管理*/}
              <CustomRoute
                path="/monitor/group/details/:groupId/:groupName"
                component={MonitorGroupDetails}
              ></CustomRoute>
              {/* dashboard */}
              <CustomRoute
                exact
                path="/monitor/dashboard/home"
                component={MonitorDashboard}
              ></CustomRoute>
              {/* dashboard-详情*/}
              <CustomRoute
                exact
                path="/monitor/dashboard/detail/private/:id"
                component={CustomboardPage}
              ></CustomRoute>
              {/* dashboard-详情-编辑*/}
              <CustomRoute
                exact
                // eslint-disable-next-line max-len
                path="/monitor/dashboard/detail/editGraph/:dashboardId/:dashboardName/:graphId"
                component={CustomboardGraphEditPage}
              ></CustomRoute>
              {/* Prometheus监控-实例列表*/}
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/instanceList"
                component={InstanceList}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/instanceList/view/:clusterId"
                component={PrometheusInstanceInfoView}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/metricexplore"
                component={PrometheusMetricExplore}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/alarm"
                component={PrometheusAlarm}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/alarm/edit"
                component={PrometheusAlarmEdit}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/alarm/view"
                component={PrometheusAlarmView}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/alarm/inhibition/edit"
                component={DenoiseInhibitionEdit}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/prometheusmonitor/alarm/slience/edit"
                component={DenoiseSilenceEdit}
              ></CustomRoute>
              {/* Grafana服务-实例列表 */}
              <CustomRoute
                exact
                path="/monitor/grafana/instancelist"
                component={GrafanaInstanceInfo}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/grafana/instancelist/view/:instanceId"
                component={GrafanaInstanceInfoView}
              ></CustomRoute>
              {/* 自动化运维 */}
              {/* 触发器 */}
              <CustomRoute
                exact
                path="/monitor/eventops/trigger"
                component={EventOpsTrigger}
              ></CustomRoute>
              {/* 触发器-记录 */}
              <CustomRoute
                exact
                path={[
                  '/monitor/eventops/trigger/record/:sign',
                  '/monitor/eventops/trigger/record/:sign/:ID'
                ]}
                component={EventOpsTriggerRecord}
              ></CustomRoute>
              {/* 自动化场景 */}
              <CustomRoute
                exact
                path="/monitor/eventops/scene"
                component={EventOpsScene}
              ></CustomRoute>
              {/* 执行场景 */}
              <CustomRoute
                exact
                path="/monitor/eventops/scene/launch/:sign"
                component={EventOpsSceneLaunch}
              ></CustomRoute>
              {/* 自动化场景-详情 */}
              <CustomRoute
                exact
                path={['/monitor/eventops/scene/detail', '/monitor/eventops/scene/detail/:sign']}
                component={EventOpsSceneDetail}
              ></CustomRoute>
              {/* 执行记录 */}
              <CustomRoute
                exact
                path="/monitor/eventops/record"
                component={EventOpsRecord}
              ></CustomRoute>
              {/* 执行记录-详情 */}
              <CustomRoute
                exact
                path="/monitor/eventops/record/detail/:ID"
                component={EventOpsRecordDetail}
              ></CustomRoute>
              {/* 公共函数 */}
              <CustomRoute
                exact
                path="/monitor/eventops/functions"
                component={EventOpsFunctions}
              ></CustomRoute>
              {/* 公共函数详情 */}
              <CustomRoute
                exact
                path="/monitor/eventops/functions/detail/:id"
                component={EventOpsFunctionDetail}
              ></CustomRoute>
              {/* 公共函数创建 */}
              <CustomRoute
                exact
                path="/monitor/eventops/functions/create"
                component={EventOpsFunctionDetail}
              ></CustomRoute>
              {/* 公共函数编辑 */}
              <CustomRoute
                exact
                path="/monitor/eventops/functions/edit/:id"
                component={EventOpsFunctionDetail}
              ></CustomRoute>
              {/* 公共函数审批 */}
              <CustomRoute
                exact
                path="/monitor/eventops/functions/approve/:ID"
                component={EventOpsFunctionApprove}
              ></CustomRoute>
              {/* 审批 */}
              <CustomRoute
                path="/monitor/eventops/approve/:Module/:ID"
                component={EventOpsApprove}
              ></CustomRoute>
              {/* AI可观测 */}
              <CustomRoute
                exact
                path="/monitor/aiobservability/serviceoverview"
                component={ServiceOverview}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/aiobservability/sessionanalysis"
                component={SessionAnalysis}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/aiobservability/sessionanalysis/detail"
                component={SessionDetail}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/aiobservability/traceanalysis"
                component={TraceAnalysis}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/aiobservability/accesscenter"
                component={AccessCenter}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/aiobservability/servicedetail"
                component={ServiceDetail}
              ></CustomRoute>
              <CustomRoute
                exact
                path="/monitor/aiobservability/traceanalysis/detail"
                component={TraceDetail}
              ></CustomRoute>
              {/* <CustomRoute exact path="/monitor/test" component={TestPage}></CustomRoute> */}
              <RedirectComponent from="/monitor/rule" to="/monitor/alarmServer/rule/home" />
              <RedirectComponent from="/" to="/monitor/generalview/home" />
            </SwitchComponent>
          </Body>
        </Layout>
      ) : null}
    </HashRouterComponent>
  )
}

export default styled(App)`
  .monitor-body {
    margin-left: 200px;
    margin-right: 0;
    padding-right: 20px;
    transition: all 0.3s ease-out;
  }
  .monitor-body-out {
    margin-left: 18px;
  }
`
